export const STORE_KEY = '@@paymentProcess'
export const CREATE_PAYMENT_TOKEN_REQUEST = `${STORE_KEY}/CREATE_PAYMENT_TOKEN_REQUEST `
export const CREATE_PAYMENT_TOKEN_SUCCESS = `${STORE_KEY}/CREATE_PAYMENT_TOKEN_SUCCESS`
export const CREATE_PAYMENT_TOKEN_FAILURE = `${STORE_KEY}/CREATE_PAYMENT_TOKEN_FAILURE`
export const POST_STRIPE_CHARGES_REQUEST = `${STORE_KEY}/POST_STRIPE_CHARGES_REQUEST`
export const POST_STRIPE_CHARGES_SUCCESS = `${STORE_KEY}/POST_STRIPE_CHARGES_SUCCESS`
export const POST_STRIPE_CHARGES_FAILURE = `${STORE_KEY}/POST_STRIPE_CHARGES_FAILURE`
